import { Flashbar } from '@amzn/awsui-components-console';
import { useApiErrors } from './ApiErrorContext';

/**
 * Tier 2: Stacked Flashbar rendering errors from ApiErrorContext.
 * Place this once in the layout — all child components push errors via context.
 */
export const ApiErrorNotifications = () => {
  const { errors } = useApiErrors();

  if (errors.length === 0) return null;

  return <Flashbar items={errors} stackItems />;
};
